import { Category } from '@apis'
import {
  Alert,
  Breadcrumb,
  Button,
  Card,
  Image,
  Row,
  Table,
  TableActions,
} from '@components'
import Fields from '@components/fields'
import {
  StyleFormFieldWrapper,
  StyleFormRowWrapper,
} from '@components/fields/style'
import { StyleCardTitle, StyleCircle, StyleColumn } from '@components/styles'
import { searchHandler } from '@utils'
import { Form, Formik } from 'formik'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

const AdminCategoryManagement = () => {
  const { id }: any = useParams()
  const { data: categories, loading: fetchLoading } = useSelector(
    (state: any) => state.bookCategories,
  )
  const { state: category } = useLocation()
  const navigate = useNavigate()
  const debounceRef: any = useRef(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false)
  const [visible, setVisible] = useState<boolean>(false)
  const [deleteId, setDeleteID] = useState(null)

  const [initialValues, setInitialValues] = useState({
    name: '',
    image: null,
  })
  const [params, setParams] = useState<any>({
    search: null,
  })

  const submitHandler = async (values: any, { resetForm }: any) => {
    setLoading(true)
    const payload: any = {
      name: values?.name,
    }
    if (values?.image?.base64) {
      payload.image = {
        extension: values?.image?.extension,
        base64: values?.image?.base64,
      }
    }
    if (!!id) {
      await Category.update(payload, id)
        .then(() => {
          resetForm()
          navigate('/admin/category-management')
        })
        .catch(() => {})
    } else {
      await Category.create(payload)
        .then(() => {
          resetForm()
        })
        .catch(() => {})
    }
    setLoading(false)
  }

  const onClickOk = async () => {
    if (!!deleteId) {
      setDeleteLoading(true)
      await Category.remove(deleteId)
        .then(() => {
          setVisible(false)
          setDeleteID(null)
        })
        .catch(() => {})
      setDeleteLoading(false)
    }
  }

  const fetchCategory = async (params: any) => {
    await Category.getAll(params).catch(() => {})
  }
  const columns = [
    {
      title: 'Department',
      key: 'name',
    },
    {
      title: 'Image',
      key: 'file',
      render: (item: any) => {
        return (
          <StyleCircle size={50} bg="adminBg">
            <Image
              src={`${process.env.BUCKET_URL}/${item?.image}`}
              width={25}
              height={25}
            />
          </StyleCircle>
        )
      },
    },
    {
      title: 'Actions',
      key: 'action',
      render: (item: any) => {
        return (
          <TableActions
            type="icon"
            hasView={false}
            onEdit={() => {
              navigate(`/admin/category-management/${item?.id}`, {
                state: item,
              })
            }}
            onDelete={() => {
              setVisible(true)
              setDeleteID(item?.id)
            }}
          />
        )
      },
    },
  ]
  useEffect(() => {
    if (!!category) {
      setInitialValues({ ...initialValues, name: category?.name })
    } else {
      setInitialValues({ ...initialValues, name: '', image: null })
    }
  }, [category])
  useEffect(() => {
    if (!categories?.length) {
      fetchCategory(params)
    }
  }, [])

  const onSearch = searchHandler({
    fetchFunction: fetchCategory,
    paramKey: 'search',
    debounceTime: 600,
    params,
    setParams,
    debounceRef,
  })
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={submitHandler}
        enableReinitialize
      >
        {({ handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Card radius={12} customStyle={{ padding: '20px 15px' }}>
                <StyleCardTitle>
                  {!!id ? 'Update' : 'Add'} Category
                </StyleCardTitle>
                <StyleColumn>
                  <StyleFormRowWrapper>
                    <StyleFormFieldWrapper width={60}>
                      <Fields.Input
                        name="name"
                        label="Category Name"
                        placeholder="Enter Category Name"
                      />
                    </StyleFormFieldWrapper>
                    <StyleFormFieldWrapper>
                      <Fields.Upload
                        label="Category Image"
                        placeholder="Upload Image"
                        varient="dashed"
                        name="image"
                        value={
                          !!id && category?.image
                            ? `${process.env.BUCKET_URL}/${category.image}`
                            : null
                        }
                      />
                    </StyleFormFieldWrapper>
                  </StyleFormRowWrapper>
                  <Row styleRow={{ marginLeft: 'auto' }}>
                    <Button
                      type="submit"
                      title="Save"
                      height={40}
                      loading={loading}
                    />
                  </Row>
                </StyleColumn>
              </Card>
            </Form>
          )
        }}
      </Formik>
      <Breadcrumb
        title="Categories"
        customStyle={{
          paddingTop: 20,
          paddingBottom: 20,
        }}
      />
      <Table
        loading={fetchLoading}
        data={categories}
        columns={columns}
        filter={{
          hasFilter: true,
          hasSearch: true,
          onSearch: onSearch,
        }}
      />
      <Alert
        loading={deleteLoading}
        title="Are you sure ?"
        description="After delete you would not recover data."
        visible={visible}
        onOk={onClickOk}
        onCancel={() => {
          setVisible(false)
        }}
      />
    </>
  )
}
export default AdminCategoryManagement
